// extracted by mini-css-extract-plugin
module.exports = {"eventLabel":"EventLabel_eventLabel__GQ9HU","date":"EventLabel_date__oh_8h"};